import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
import useApi from "../../../core/customhook/useApi";
import axios from "axios";
import { apibaseurl, jwttoken } from "../../../environment";
import Swal from "sweetalert2";
import Loader from "../../../core/common/selfLoder";

interface Sop {
  sops_id: string;
  sops_name: string;
}

interface SopResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: Sop[];
}

interface SopAllData {
  ID: number;
  sop_title: string;
  sop_category: string;
  sop_file: string;
}

interface SopMainResponse {
  success: boolean;
  message: string;
  statusCode: number;
  data: SopAllData[];
}

const Sops: React.FC = () => {
  const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
  const [acceptSop, setAcceptSop] = useState<number[]>([]);
  const [activeTab, setActiveTab] = useState("");
  const [loading, setLoading] = useState(false);

  const [filter, setFilter] = useState("all"); // or "accepted" | "notAccepted"


  const {
    data: sopData,
    loading: sopDataLoading,
    error: sopDataError,
  } = useApi<SopResponse>("/api/master/get-sops", {
    method: "GET",
    autoCall: true,
  });

  const {
    data: sopAllData,
    loading: sopAllDataLoading,
    error: sopAllDataError,
  } = useApi<SopMainResponse>("/api/get-sops", {
    method: "POST",
    autoCall: true,
    payload: { category: activeTab },
    dependencies: [activeTab],
  });

  const {
    data: acceptedSopsResponse,
    callApi: fetchAcceptedSops,
    loading: acceptedSopsLoading,
  } = useApi("/api/accepted-sops", {
    method: "GET",
    autoCall: false,
  });

  const acceptedsops = async () => {
    try {
      const response = await fetchAcceptedSops();
      if (response?.success) {
        const acceptedIds = response.data.map((item: any) =>
          Number(item.sop_id)
        );
        setAcceptSop(acceptedIds);
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response?.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while fetching accepted SOPs.",
      });
    }
  };

  const { callApi: acceptSopApi } = useApi<{
    success: boolean;
    message?: string;
  }>("/api/accept-sops", {
    method: "POST",
    autoCall: false,
  });

  const acceptsops = async (sopID: number) => {
    const confirmResult = await Swal.fire({
      title: "Are you sure?",
      text: "Do you really want to accept this SOP?",
      icon: "warning",
      showCancelButton: true,
      confirmButtonColor: "#3085d6",
      cancelButtonColor: "#d33",
      confirmButtonText: "Yes, accept it!",
    });

    if (!confirmResult.isConfirmed) return;
    try {
      setLoading(true);
      const response = await acceptSopApi({ sop_id: sopID });
      if (response?.success) {
        Swal.fire({
          icon: "success",
          title: "SOP Accepted!",
          text: "You have successfully accepted the SOP.",
          timer: 2000,
          showConfirmButton: true,
        });
        await acceptedsops();
      } else {
        Swal.fire({
          icon: "error",
          title: "Failed",
          text: response?.message || "Something went wrong!",
        });
      }
    } catch (error) {
      Swal.fire({
        icon: "error",
        title: "Error",
        text: "Something went wrong while accepting the SOP.",
      });
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    acceptedsops();
  }, []);
  return (
    <>
      <Loader
        loading={sopDataLoading || sopAllDataLoading || loading}

      />
      <div className="page-wrapper">
        <div className="content">
          {/* Breadcrumb */}
          <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
            <div className="my-auto mb-2">
              <h2 className="mb-1">Standard Procedures</h2>
              <nav>
                <ol className="breadcrumb mb-0">
                  <li className="breadcrumb-item">
                    <Link to="/employee-dashboard">
                      <i className="ti ti-smart-home" />
                    </Link>
                  </li>
                  <li className="breadcrumb-item">Company Overview</li>
                  <li className="breadcrumb-item active" aria-current="page">
                    Standard Procedures
                  </li>
                </ol>
              </nav>
            </div>
            <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
              <div className="head-icons ms-2">
                <CollapseHeader />
              </div>
            </div>
          </div>
          {/* /Breadcrumb */}

          {/* Tabs */}
          <div className="card">
            <div className="card-body p-3">
              <div className="d-flex align-items-center justify-content-center">
                <div
                  className="w-100"
                  style={{
                    overflowX: "auto",
                    whiteSpace: "nowrap",
                  }}
                >
                  <ul
                    className="nav nav-tabs justify-content-center flex-nowrap"
                    style={{ minWidth: "max-content", overflowY: "hidden" }}
                  >
                    <li className="nav-item d-inline-block">
                      <button
                        className="nav-link px-3 px-md-4 py-2 mb-1"
                        onClick={() => setActiveTab("")}
                        style={{
                          backgroundColor: activeTab === "" ? "#2e3294" : "transparent",
                          color: activeTab === "" ? "white" : "#2e3294",
                          border: "1px solid #2e3294",
                          borderRadius: "15px",
                          fontWeight: "500",
                        }}
                      >
                        All
                      </button>
                    </li>
                    {sopData?.data.map((tab) => (
                      <li className="nav-item d-inline-block" key={tab.sops_id}>
                        <button
                          className="nav-link px-3 px-md-4 py-2 mb-1"
                          onClick={() => setActiveTab(tab.sops_id)}
                          style={{
                            backgroundColor:
                              activeTab === tab.sops_id ? "#2e3294" : "transparent",
                            color:
                              activeTab === tab.sops_id ? "white" : "#2e3294",
                            border: "1px solid #2e3294",
                            borderRadius: "15px",
                            fontWeight: "500",
                          }}
                        >
                          {tab.sops_name}
                        </button>
                      </li>
                    ))}
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Filter Buttons */}
          <div className="mb-4 d-flex flex-wrap gap-2">
            {([
              { label: "All", value: "all" },
              { label: "Accepted", value: "accepted" },
              { label: "Acceptance Pending", value: "notAccepted" },
            ] as const).map((btn) => {
              const isActive = filter === btn.value;

              return (
                <button
                  key={btn.value}
                  onClick={() => setFilter(btn.value)}
                  className="btn btn-sm"
                  style={{
                    backgroundColor: isActive ? "#2e3294" : "#e6e7fa", // Secondary theme
                    color: isActive ? "#ffffff" : "#2e3294",            // Text color toggle
                    border: "1px solid #2e3294",
                    borderRadius: "8px",
                    padding: "6px 14px",
                    fontWeight: 500,
                    transition: "all 0.3s ease",
                  }}
                >
                  {btn.label}
                </button>
              );
            })}
          </div>

          {/* SOP Cards */}
          <div className="card border-0 shadow-sm">
            <div className="card-body">
              <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
                {sopAllData?.data && sopAllData?.data.length > 0 ? (
                  (() => {
                    const filteredSOPs = sopAllData.data.filter((sop) => {
                      const isAccepted = acceptSop.includes(sop.ID);
                      if (filter === "accepted") return isAccepted;
                      if (filter === "notAccepted") return !isAccepted;
                      return true;
                    });

                    if (filteredSOPs.length === 0) {
                      return (
                        <div className="col-12 text-center">
                          <p>
                            {filter === "accepted"
                              ? "No Accepted SOPs found."
                              : filter === "notAccepted"
                                ? "No Acceptance Pending SOPs found."
                                : "No SOPs available."}
                          </p>
                        </div>
                      );
                    }

                    return filteredSOPs.map((sop, index) => {
                      const isAccepted = acceptSop.includes(sop.ID);

                      return (
                        <div className="col" key={index}>
                          <div className="card h-100 border shadow-sm mb-0">
                            <div className="card-header bg-white border-bottom-0">
                              <p
                                className="mb-1"
                                style={{
                                  color: "#2e3294",
                                  fontSize: "18px",
                                  fontWeight: "500",
                                }}
                              >
                                {sop.sop_title}
                              </p>
                              <div className="text-start mt-2">
                                {isAccepted ? "SOP Accepted" : "Acceptance Pending"}
                              </div>
                            </div>

                            <div className="card-body d-flex flex-column justify-content-between">
                              <div className="d-flex justify-content-between mt-auto">

                                <button
                                  className="btn btn-sm"
                                  style={{
                                    backgroundColor: isAccepted
                                      ? "#198754" : "#2e3294ad",
                                    color: "#fff",
                                    border: "none",
                                  }}
                                  disabled={isAccepted}
                                  onClick={() => acceptsops(sop.ID)}
                                >
                                  {isAccepted ? (
                                    <>
                                      <i className="bi bi-check-circle me-1"></i> Accepted
                                    </>
                                  ) : (
                                    <>
                                      <i className="bi bi-check2-square me-1"></i> Accept
                                    </>
                                  )}
                                </button>
                                {sop.sop_file ? (
                                  <button
                                    className="btn btn-sm"
                                    style={{
                                      backgroundColor: "#2e3294",
                                      color: "#fff",
                                      border: "none",
                                    }}
                                    data-bs-toggle="modal"
                                    data-bs-target="#pdfModal"
                                    onClick={() => setSelectedPdf(sop.sop_file)}
                                  >
                                    <i className="bi bi-eye me-1"></i> View
                                  </button>
                                ) : (
                                  <button className="btn btn-secondary btn-sm" disabled>
                                    No PDF
                                  </button>
                                )}

                              </div>
                            </div>
                          </div>
                        </div>
                      );
                    });
                  })()
                ) : (
                  <div className="col-12 text-center">
                    <p>No SOPs available.</p>
                  </div>
                )}
              </div>
            </div>
          </div>


          {/* /SOP Cards */}
        </div>

        {/* PDF Modal */}
        {/* PDF Modal */}
        <div
          className="modal fade"
          id="pdfModal"
          tabIndex={-1}
          aria-labelledby="pdfModalLabel"
          aria-hidden="true"
        >
          <div className="modal-dialog modal-lg">
            <div className="modal-content">
              <div className="modal-header">
                <h5 className="modal-title" id="pdfModalLabel">
                  Document Preview
                </h5>
                <button
                  type="button"
                  className="btn-close"
                  data-bs-dismiss="modal"
                  aria-label="Close"
                  onClick={() => setSelectedPdf(null)}
                ></button>
              </div>
              <div className="modal-body">
                {selectedPdf ? (
                  <iframe
                    src={selectedPdf}
                    width="100%"
                    height="500px"
                    style={{ border: "none" }}
                    title="PDF Preview"
                  />
                ) : (
                  <p>No document selected.</p>
                )}
              </div>
            </div>
          </div>
        </div>

        {/* /PDF Modal */}

        {/* Footer */}
        <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
          <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
        </div>
      </div>
    </>
  );
};

export default Sops;




// import React, { useEffect, useState } from "react";
// import { Link } from "react-router-dom";
// import CollapseHeader from "../../../core/common/collapse-header/collapse-header";
// import useApi from "../../../core/customhook/useApi";
// import axios from "axios";
// import { apibaseurl, jwttoken } from "../../../environment";
// import Swal from "sweetalert2";
// import Loader from "../../../core/common/selfLoder";

// interface Sop {
//   sops_id: string;
//   sops_name: string;
// }

// interface SopResponse {
//   success: boolean;
//   message: string;
//   statusCode: number;
//   data: Sop[];
// }

// interface SopAllData {
//   ID: number;
//   sop_title: string;
//   sop_category: string;
//   sop_file: string;
// }

// interface SopMainResponse {
//   success: boolean;
//   message: string;
//   statusCode: number;
//   data: SopAllData[];
// }

// const Sops: React.FC = () => {
//   const [selectedPdf, setSelectedPdf] = useState<string | null>(null);
//   const [acceptSop, setAcceptSop] = useState<number[]>([]);
//   const [activeTab, setActiveTab] = useState("");
//   const [loading, setLoading] = useState(false);

//   const {
//     data: sopData,
//     loading: sopDataLoading,
//     error: sopDataError,
//   } = useApi<SopResponse>("/api/master/get-sops", {
//     method: "GET",
//     autoCall: true,
//   });

//   const {
//     data: sopAllData,
//     loading: sopAllDataLoading,
//     error: sopAllDataError,
//   } = useApi<SopMainResponse>("/api/get-sops", {
//     method: "POST",
//     autoCall: true,
//     payload: { category: activeTab },
//     dependencies: [activeTab],
//   });

//   const {
//     data: acceptedSopsResponse,
//     callApi: fetchAcceptedSops,
//     loading: acceptedSopsLoading,
//   } = useApi("/api/accepted-sops", {
//     method: "GET",
//     autoCall: false,
//   });

//   const acceptedsops = async () => {
//     try {
//       const response = await fetchAcceptedSops();
//       if (response?.success) {
//         const acceptedIds = response.data.map((item: any) =>
//           Number(item.sop_id)
//         );
//         setAcceptSop(acceptedIds);
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Failed",
//           text: response?.message || "Something went wrong!",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Something went wrong while fetching accepted SOPs.",
//       });
//     }
//   };

//   const { callApi: acceptSopApi } = useApi<{
//     success: boolean;
//     message?: string;
//   }>("/api/accept-sops", {
//     method: "POST",
//     autoCall: false,
//   });

//   const acceptsops = async (sopID: number) => {
//     const confirmResult = await Swal.fire({
//       title: "Are you sure?",
//       text: "Do you really want to accept this SOP?",
//       icon: "warning",
//       showCancelButton: true,
//       confirmButtonColor: "#3085d6",
//       cancelButtonColor: "#d33",
//       confirmButtonText: "Yes, accept it!",
//     });

//     if (!confirmResult.isConfirmed) return;
//     try {
//       setLoading(true);
//       const response = await acceptSopApi({ sop_id: sopID });
//       if (response?.success) {
//         Swal.fire({
//           icon: "success",
//           title: "SOP Accepted!",
//           text: "You have successfully accepted the SOP.",
//           timer: 2000,
//           showConfirmButton: true,
//         });
//         await acceptedsops();
//       } else {
//         Swal.fire({
//           icon: "error",
//           title: "Failed",
//           text: response?.message || "Something went wrong!",
//         });
//       }
//     } catch (error) {
//       Swal.fire({
//         icon: "error",
//         title: "Error",
//         text: "Something went wrong while accepting the SOP.",
//       });
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     acceptedsops();
//   }, []);
//   return (
//     <>
//       <Loader
//         loading={sopDataLoading || sopAllDataLoading || loading}

//       />
//       <div className="page-wrapper">
//         <div className="content">
//           {/* Breadcrumb */}
//           <div className="d-md-flex d-block align-items-center justify-content-between page-breadcrumb mb-3">
//             <div className="my-auto mb-2">
//               <h2 className="mb-1">Standard Procedures</h2>
//               <nav>
//                 <ol className="breadcrumb mb-0">
//                   <li className="breadcrumb-item">
//                     <Link to="/employee-dashboard">
//                       <i className="ti ti-smart-home" />
//                     </Link>
//                   </li>
//                   <li className="breadcrumb-item">Dashboard</li>
//                   <li className="breadcrumb-item active" aria-current="page">
//                     Standard Procedures
//                   </li>
//                 </ol>
//               </nav>
//             </div>
//             <div className="d-flex my-xl-auto right-content align-items-center flex-wrap">
//               <div className="head-icons ms-2">
//                 <CollapseHeader />
//               </div>
//             </div>
//           </div>
//           {/* /Breadcrumb */}

//           {/* Tabs */}
//           <div className="card">
//             <div className="card-body p-3">
//               <div className="d-flex align-items-center justify-content-center">
//                 <div
//                   className="w-100"
//                   style={{
//                     overflowX: "auto",
//                     whiteSpace: "nowrap",
//                   }}
//                 >
//                   <ul
//                     className="nav nav-tabs justify-content-center flex-nowrap"
//                     style={{ minWidth: "max-content", overflowY: "hidden" }}
//                   >
//                     <li className="nav-item d-inline-block">
//                       <button
//                         className="nav-link px-3 px-md-4 py-2 rounded mb-1"
//                         onClick={() => setActiveTab("")}
//                         style={{
//                           backgroundColor:
//                             activeTab === "" ? "#F89520" : "transparent",
//                           color: activeTab === "" ? "white" : "black",
//                           border: "1px solid",
//                           borderColor: activeTab === "" ? "#F89520" : "#ddd",
//                         }}
//                       >
//                         All
//                       </button>
//                     </li>
//                     {sopData?.data.map((tab) => (
//                       <li className="nav-item d-inline-block" key={tab.sops_id}>
//                         <button
//                           className="nav-link px-3 px-md-4 py-2 rounded mb-1"
//                           onClick={() => setActiveTab(tab.sops_id)}
//                           style={{
//                             backgroundColor:
//                               activeTab === tab.sops_id
//                                 ? "#F89520"
//                                 : "transparent",
//                             color:
//                               activeTab === tab.sops_id ? "white" : "black",
//                             border: "1px solid",
//                             borderColor:
//                               activeTab === tab.sops_id ? "#F89520" : "#ddd",
//                           }}
//                         >
//                           {tab.sops_name}
//                         </button>
//                       </li>
//                     ))}
//                   </ul>
//                 </div>
//               </div>
//             </div>
//           </div>

//           {/* /Tabs */}

//           {/* SOP Cards */}
//           {/* <div className="card">
//             <div className="card-body">
//               <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//                 {sopAllData?.data && sopAllData?.data.length > 0 ? (
//                   sopAllData?.data.map((sop, index) => (
//                     <div className="col" key={index}>
//                       <div className="card">
//                         <div className="card-header">
//                           <div className="card-title">{sop.sop_title}</div>
//                           <p className="card-text">
//                             Status:{" "}
//                             <span>
//                               {acceptSop.includes(sop.ID) ? (
//                                 <strong className="text-success">
//                                   SOPs Accepted
//                                 </strong>
//                               ) : (
//                                 <strong className="text-danger">
//                                   Acceptance Pending SOPs
//                                 </strong>
//                               )}
//                             </span>
//                           </p>
//                         </div>
//                         <div className="card-body d-flex justify-content-between">
//                           {sop.sop_file ? (
//                             <button
//                               className="btn btn-primary"
//                               onClick={() => openModal(sop.sop_file)}
//                             >
//                               View
//                             </button>
//                           ) : (
//                             <button className="btn btn-secondary" disabled>
//                               No PDF
//                             </button>
//                           )}
//                           <button
//                             className="btn"
//                             style={{
//                               backgroundColor: "#F89520",
//                               color: "white",
//                             }}
//                             disabled={acceptSop.includes(sop.ID)}
//                             onClick={() => acceptsops(sop.ID)}
//                           >
//                             {acceptSop.includes(sop.ID) ? "Accepted" : "Accept"}
//                           </button>
//                         </div>
//                       </div>
//                     </div>
//                   ))
//                 ) : (
//                   <div>No SOPs available</div>
//                 )}
//               </div>
//             </div>
//           </div> */}

//           <div className="card">
//             <div className="card-body">
//               <div className="row row-cols-1 row-cols-md-2 row-cols-lg-3 g-4">
//                 {sopAllData?.data && sopAllData?.data.length > 0 ? (
//                   sopAllData?.data.map((sop, index) => {
//                     const isAccepted = acceptSop.includes(sop.ID);

//                     return (
//                       <div className="col" key={index}>
//                         <div className="card h-100 border shadow-sm">
//                           <div className="card-header bg-white border-bottom-0">
//                             <h5 className="card-title text-primary mb-1">
//                               <i className="bi bi-journal-text me-2"></i>
//                               {sop.sop_title}
//                             </h5>
//                             <span
//                               className={`badge ${isAccepted ? "bg-success" : "bg-danger"
//                                 } mt-2`}
//                             >
//                               {isAccepted
//                                 ? "SOP Accepted"
//                                 : "Acceptance Pending"}
//                             </span>
//                           </div>

//                           <div className="card-body mt-auto d-flex justify-content-between align-items-center">
//                             {sop.sop_file ? (
//                               <button
//                                 className="btn btn-outline-primary btn-sm"
//                                 data-bs-toggle="modal"
//                                 data-bs-target="#pdfModal"
//                                 onClick={() => setSelectedPdf(sop.sop_file)}
//                               >
//                                 <i className="bi bi-eye me-1"></i> View
//                               </button>
//                             ) : (
//                               <button
//                                 className="btn btn-secondary btn-sm"
//                                 disabled
//                               >
//                                 No PDF
//                               </button>
//                             )}

//                             <button
//                               className={`btn btn-sm ${isAccepted
//                                 ? "btn-success"
//                                 : "btn-warning text-white"
//                                 }`}
//                               disabled={isAccepted}
//                               onClick={() => acceptsops(sop.ID)}
//                             >
//                               {isAccepted ? (
//                                 <>
//                                   <i className="bi bi-check-circle me-1"></i>{" "}
//                                   Accepted
//                                 </>
//                               ) : (
//                                 <>
//                                   <i className="bi bi-check2-square me-1"></i>{" "}
//                                   Accept
//                                 </>
//                               )}
//                             </button>
//                           </div>
//                         </div>
//                       </div>
//                     );
//                   })
//                 ) : (
//                   <div className="col-12 text-center">
//                     <p>No SOPs available.</p>
//                   </div>
//                 )}
//               </div>
//             </div>
//           </div>

//           {/* /SOP Cards */}
//         </div>

//         {/* PDF Modal */}
//         {/* PDF Modal */}
//         <div
//           className="modal fade"
//           id="pdfModal"
//           tabIndex={-1}
//           aria-labelledby="pdfModalLabel"
//           aria-hidden="true"
//         >
//           <div className="modal-dialog modal-lg">
//             <div className="modal-content">
//               <div className="modal-header">
//                 <h5 className="modal-title" id="pdfModalLabel">
//                   Document Preview
//                 </h5>
//                 <button
//                   type="button"
//                   className="btn-close"
//                   data-bs-dismiss="modal"
//                   aria-label="Close"
//                   onClick={() => setSelectedPdf(null)}
//                 ></button>
//               </div>
//               <div className="modal-body">
//                 {selectedPdf ? (
//                   <iframe
//                     src={selectedPdf}
//                     width="100%"
//                     height="500px"
//                     style={{ border: "none" }}
//                     title="PDF Preview"
//                   />
//                 ) : (
//                   <p>No document selected.</p>
//                 )}
//               </div>
//             </div>
//           </div>
//         </div>

//         {/* /PDF Modal */}

//         {/* Footer */}
//         <div className="footer d-flex align-items-center justify-content-center   border-top bg-white p-3">
//           <p className="mb-0">© {new Date().getFullYear()} WeConnect. All rights reserved.</p>
//         </div>
//       </div>
//     </>
//   );
// };

// export default Sops;
